export const borderColor = 'border-tertiary-200';

export const borderStyles = {
    small: `border ${borderColor}`,
    medium: `border ${borderColor}`,
    large: `border ${borderColor}`,
};

export const borderRadiusBySize = {
    small: 'rounded-lg',
    medium: 'rounded-sm',
    large: 'rounded-sm',
};

export const iconFillColors = {
    small: 'white',
    medium: 'black',
    large: 'black',
    disabled: 'tertiary-400',
};

export const iconWidths = {
    small: 12,
    medium: 14,
    large: 20,
};

export const descriptionStyles = {
    small: 'text-white font-normal',
    medium: 'text-tertiary-300 font-semibold',
    large: 'text-tertiary-300 font-semibold',
};

export const defaultHeights = {
    small: 25,
    medium: 40,
    large: 50,
};

export const defaultWidths = {
    small: 150,
    medium: 200,
    large: 200,
};

export const headerLeftPadding = {
    small: 'pl-2',
    medium: 'pl-2',
    large: 'pl-3',
};

export const defaultSize = 'medium';
export const defaultDisabled = false;
export const defaultBorderConfig = 'from-size';
export const borderShim = 2;
